import { render, staticRenderFns } from "./MedPaymentInput.vue?vue&type=template&id=65228cac"
import script from "./MedPaymentInput.vue?vue&type=script&lang=js"
export * from "./MedPaymentInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports